import { CaregiverPatientDocument, CaregiverPatientDocumentType } from "../messages";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { fmap } from "../utils/fmap";
import { isDefined } from "./Generic/IsDefined";

export function isDocumentSubmittedManually(doc: CaregiverPatientDocument) {
  return doc.type === CaregiverPatientDocumentType.ManualSubmission;
}

export function isDocumentSubmitted(doc: CaregiverPatientDocument) {
  return "submittedAt" in doc && isDefined(doc.submittedAt);
}

export function isDocumentNotSubmitted(doc: CaregiverPatientDocument) {
  return !("submittedAt" in doc) || !isDefined(doc.submittedAt);
}

export function parseErrorResponse(error: any) {
  if (error === undefined || !Number.isInteger(error.statusCode)) {
    return translate(STRINGS.SOMETHING_WENT_WRONG);
  }

  const parsedBody = fmap(error.body, (x) => JSON.parse(x.toString()));

  if (parsedBody === null || parsedBody.error === undefined) {
    return translate(STRINGS.SOMETHING_WENT_WRONG);
  }

  switch (parsedBody.error) {
    case "INVALID_SSN":
      return translate(STRINGS.INVALID_SSN_PLEASE_CHECK_AND_TRY_AGAIN);
    default:
      return translate(STRINGS.SOMETHING_WENT_WRONG);
  }
}
